import { render, staticRenderFns } from "./isolate-add.vue?vue&type=template&id=41f2e8ec&"
import script from "./isolate-add.vue?vue&type=script&lang=js&"
export * from "./isolate-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports